// src/queryClient.js - Updated to include tenant in query keys
import { QueryClient } from 'react-query';
import { extractTenantFromHostname } from './utils/tenant';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
      // Add tenant key to all query keys
      queryKeyHashFn: (queryKey) => {
        // Add tenant to query key to isolate cache by tenant
        const tenant = extractTenantFromHostname();
        if (Array.isArray(queryKey)) {
          return JSON.stringify([tenant, ...queryKey]);
        }
        return JSON.stringify([tenant, queryKey]);
      }
    },
  },
});

// Add a function to reset the query cache on tenant change
export const resetQueryCacheForTenantChange = () => {
  console.log('Resetting query cache due to tenant change');
  return queryClient.clear();
};